'use client'

import { useEffect } from "react";
import { usePostHog } from 'posthog-js/react';
import { Button } from '@/components/ui/button'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const posthog = usePostHog()

  useEffect(() => {
    posthog.captureException(error);
  }, [error, posthog]);

  return (
    <div className="flex h-screen w-full flex-col items-center justify-center">
      <div className="mx-auto max-w-md text-center">
        <h2 className="text-2xl font-bold text-foreground">
          Something went wrong!
        </h2>
        <p className="mt-4 text-muted-foreground">
          We&apos;ve encountered an unexpected error. Our team has been notified and is working on a fix.
        </p>
        <div className="mt-6">
          <Button onClick={reset}>
            Try again
          </Button>
        </div>
      </div>
    </div>
  );
}
